<template>
<div class="form-step-item">
    <div class="panel">
        <div class="intro">
            <h3>Consumables Required</h3>
            <p>Select items required, quantity (lowest possible unit of measure) and frequency. This information will form the regimen for monthly consumables orders and assist us in conducting stocktakes with the HPNer.For product catalogue please log into Baxter Professional.</p>
        </div>
        <div class="consumables-list">
            <div class="consumable-item" v-for="(item, index) in this.formData.consumables_list" :key="index" >
                <ConsumableRow :index="index" :item="item" :formData="formData" :defaultSettings="defaultSettings" :ref="'consumable_row_' + index" @consumables_validation_response="OnConsumablesValidationResponse"></ConsumableRow>
            </div>
            <button class="consumable-add" v-on:click="addConsumableRow">Add another consumable</button>
        </div>
        <div class="form-row">
            <div class="form-group col-12">
                <label for="consumables_notes">Special requirements (specify delivery of consumables to home, hospital or other)</label>
                <textarea class="form-control" v-model="formData.consumables_notes"></textarea>
            </div>
        </div>
    </div>
</div>
</template>


<script>

import ConsumableRow from '@/views/Tpn/PatientRegister/ConsumableRow.vue';

export default {
    name: 'FormStep7',
    components: {
        ConsumableRow,
    },
    props: {
        formData: {
            required: true,
        },
        defaultSettings: {
            required: true,
        },
    },
    data() {
        return {
            validConsumablesList: true,
        };
    },
    validations: {
    },
    computed: {
    },
    methods: {
        validateForm() {
            this.$v.$touch();

            // loop through consumables to run validation
            for (let i = 0; i < this.formData.consumables_list.length; i += 1) {
                this.$refs['consumable_row_' + i][0].validateForm();
            }
            this.$emit('validation_response', !this.$v.$invalid && this.validConsumablesList);
        },
        OnConsumablesValidationResponse(response) {
            this.validConsumablesList = response;
        },
        addConsumableRow() {
            this.formData.consumables_list.push({ name: '', qty: '', frequency: '' });
        },
    },
};
</script>
